import { render, staticRenderFns } from "./PaymentPayerSettlementForm.vue?vue&type=template&id=31e55a3c&scoped=true"
import script from "./PaymentPayerSettlementForm.vue?vue&type=script&lang=js"
export * from "./PaymentPayerSettlementForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentPayerSettlementForm.vue?vue&type=style&index=0&id=31e55a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e55a3c",
  null
  
)

export default component.exports